<template>
    <div>
        <b-modal
            id="clockInModal"
            ref="clockInModal"
            :lazy="true"
            title-tag="h2"
            title="Clock In"
        >
            <!-- Modal Form -->
            <div
                id="dialog-alert-warning"
                class="alert alert-block alert-warning show"
                style="padding: 10px;"
            >
                <span id="dialog-alert-message">
                    Hi, {{ $root.currentActor.fullname }}. It is
                    <span id="clock-start">{{ clock_in_time }}</span>
                    on {{ clock_in_day }}, {{ clock_in_date }}. Ready to clock
                    in?
                </span>
            </div>
            <div style="border-top: 1px solid #ddd; padding-top: 20px;" />
            <form class="form-horizontal">
                <div class="form-group row">
                    <label for="current" class="col-sm-3 col-form-label"
                        >Staff Notes:</label
                    >
                    <div class="col-sm-9">
                        <textarea
                            id="comments"
                            v-model="data.comments"
                            class="form-control"
                            placeholder="Notes (optional)"
                            style="height: 80px !important;"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.clockInModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="clockin" v-else variant="primary"
                        >Clock In</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {
                clock_start: null,
                comments: null
            },
            clock_in_time: null,
            clock_in_day: null,
            clock_in_date: null,
            date_format: "DD/MM/YYYY",
            time_format: "h:mm A",
            loading: false
        };
    },
    computed: {},
    methods: {
        open() {
            this.getClockIn();
            this.date_format = this.getDateFormat();
        },
        getClockIn() {
            let self = this;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff/clock-in")
                .then(function (response) {
                    if (response.data.response.message.code == 200) {
                        self.data.clock_start =
                            response.data.response.resource.message.clock_start;

                        self.clock_in_time = moment
                            .unix(self.data.clock_start)
                            .tz(self._timeZone)
                            .format(self.time_format);

                        self.clock_in_day = moment
                            .unix(self.data.clock_start)
                            .tz(self._timeZone)
                            .format("dddd");

                        self.clock_in_date = moment
                            .unix(self.data.clock_start)
                            .tz(self._timeZone)
                            .format(self.date_format);

                        self.$refs.clockInModal.show();
                    } else {
                        self.$root.$emit(
                            "message",
                            response.data.response.resource.message,
                            "danger"
                        );
                    }
                });
        },
        clockin() {
            let self = this;

            self.loading = true;

            let post = {
                clock_start: self.data.clock_start,
                comments: self.data.comments
            };
            return this.$http
                .post(process.env.ACTOR_SERVICE + "staff/clock-in", post)
                .then(function (response) {
                    if (response.data.response.message.code == 200) {
                        if (response.data.response.resource.message)
                            self.$root.$emit(
                                "message",
                                response.data.response.resource.message,
                                "success"
                            );

                        self.$root.timesheet.clock_in = false;
                        self.$root.timesheet.clock_out = true;

                        localStorage.setItem(
                            response.data.response.resource.data.storage_key,
                            JSON.stringify({
                                extension_enabled: true,
                                active_time_clock: true
                            })
                        );

                        self.$refs.clockInModal.hide();
                    } else {
                        self.$root.$emit(
                            "message",
                            response.data.response.resource.message,
                            "danger"
                        );
                    }
                })
                .finally(() => (self.loading = false));
        }
    }
};
</script>
